/* eslint-disable */
import axios from 'axios';
import { stat } from 'fs';


export default {

    state : {
        mainReportOrders : [],
    },

   
    getters : {

        getMainReportOrders(state) {
            return state.mainReportOrders;
        },

        // allCharges(state) {
        //     return state.charges.sort( (a,b)=>{return a.id > b.id ? -1 : 1});
        // },

    },

    mutations: {

        setMainReportOrders(state, data) {
            // здесь нужно сразу распарсить JSON - дабы ускорить процесс
            data.forEach(item => {
                item.options = item.options != null ? JSON.parse(item.options) : {};
            });
            // сохраняем в state
            state.mainReportOrders = data;
        }

    },

    actions : {

        getMainReport({dispatch, commit, rootState}, data) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;
            axios.post('/getMainReport', data) //получаем отчет
                .then(response => {
                    commit('setMainReportOrders', response.data)                 
                })
                .catch(error => {
                    reject(error.response.status)
            });
        }

    }

}